/**
 * Combined listings: speed up sibling color navigation (added 2026-08-25).
 *
 * rev 2 (aug 25): PRERENDER → PREFETCH. Prerendering ran the sibling page's
 * full JS (galleries, rails, 200ms pollers, ResizeObservers) in background
 * tabs — hovering across a 13-color picker spun up enough of them to peg the
 * main thread and freeze the visible page. Document prefetch just warms the
 * HTML over the network: nearly the same perceived speed, none of the CPU.
 * At most 6 sibling documents are prefetched per page view.
 */
(function () {
  var done = {};
  var count = 0;
  var MAX = 6;

  function speculate(url) {
    if (!url || done[url] || count >= MAX) return;
    done[url] = true;
    count += 1;

    try {
      if (
        window.HTMLScriptElement &&
        HTMLScriptElement.supports &&
        HTMLScriptElement.supports('speculationrules')
      ) {
        var s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({ prefetch: [{ urls: [url] }] });
        document.head.appendChild(s);
        return;
      }
    } catch (e) {
      /* fall through to link prefetch */
    }

    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  function arm(el, url) {
    var opts = { once: true, passive: true };
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) {
      el.addEventListener(ev, function () { speculate(url); }, opts);
    });
  }

  function hookup() {
    document.querySelectorAll('[data-product-url]').forEach(function (el) {
      var url = el.dataset.productUrl;
      if (!url) return;
      // Radios are visually hidden; hover happens on the wrapping swatch item.
      var target = el.closest('.product-form__swatch__item') || el;
      arm(target, url);
    });
    // Sibling color rail thumbs are plain links — warm those too.
    document.querySelectorAll('a.pdp-color-rail__thumb[href]').forEach(function (a) {
      arm(a, a.getAttribute('href'));
    });
  }

  if (document.readyState !== 'loading') hookup();
  else document.addEventListener('DOMContentLoaded', hookup);
})();
